import React from "react";
import Header from "../layout/Header";
import { Footer } from "../layout/Footer";

const DataPrivacy = () => {
  return (
    <div className="site-main">
      <Header />
      <div className="ttm-page-title-row">
        <div className="container-xl">
          <div className="row">
            <div className="col-md-12">
              <div className="title-box text-center">
                <div className="page-title-heading">
                  <h1 className="title">User Data and Privacy Policy</h1>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="margin-top-css">
        <div className="container-xl">
          <div className="float-right">Modified on : 07-May-2025</div>
          <div class="section">
            <h3>User Data</h3>

            <p>
              User may export the content, manage who use it and their roles,
              create integrations, manage permissions, create information types,
              change settings, adjust privacy, delete all or some of the
              Content, or share User Data.
            </p>
            <p>
              User Data is supplied by the User and the sole responsibility for
              the User Data belongs to the User. We do not check any part of the
              User Data and are not responsible in any way for its contents,
              including but not limited to whether it infringes on anyone else’s
              copyrights, violates any laws, or contains offensive or otherwise
              sensitive information.
            </p>
          </div>

          <div class="section">
            <h3 style={{ color: "purple" }}>Scope</h3>
            <p>
              We collect certain information through our Site, including through
              the products and services provided on the Site. This Privacy
              Policy lays out our policies and procedures surrounding the
              collection and handling of any such data that identifies an
              individual user, or that could be used to contact or locate him or
              her personally.
            </p>
            <p>
              This Privacy Policy applies only to our Site and to the products
              and services provided through our Site. It does not apply to any
              third-party site or service linked to our Site or recommended or
              referred by our Site, through our products or services, or by our
              staff. And it does not apply to any other website, product, or
              service operated by us, or to any of our offline activities.
            </p>
            <p>
              This privacy policy applies to individuals visiting our website,
              whether they reside in the India or not. However, rights given
              under the Information Technology Act, 2000 can only be exercised
              by individuals residing in the India.
            </p>
            <p class="legal-note">
              Transmitting information over the internet is generally not
              completely secure, and <strong>Cognitude Technologies</strong>{" "}
              cannot guarantee the security of an individual’s data. Any data an
              individual transmits to the{" "}
              <strong>Cognitude Technologies</strong> is sent at their own risk.
            </p>
          </div>

          <div class="section">
            <h3 style={{ color: "purple" }}>
              If you are located in the India, this part applies to you.
            </h3>
            <p>
              The Digital Personal Data Protection Act, 2023 provides for the
              processing of digital personal data in a manner that recognises
              both the right of individuals to protect their personal data and
              the need to process such personal data for lawful purposes and for
              matters connected therewith or incidental thereto.
            </p>
            <p>
              As such, we may rely on the following legal bases to process your
              personal information:
            </p>
            <ul>
              <li>
                <strong>Consent:</strong> We may process your information if you
                have given us permission (i.e., consent) to use your personal
                information for a specific purpose. You can withdraw your
                consent at any time.
              </li>
              <li>
                <strong>Performance of a Contract:</strong> We may process your
                personal information when we believe it is necessary to fulfil
                our contractual obligations to you, including providing our
                Services or at your request prior to entering into a contract
                with you.
              </li>
              <li>
                <strong>Legitimate Interests:</strong> We may process your
                information when we believe it is reasonably necessary to
                achieve our legitimate business interests and those interests do
                not outweigh your interests and fundamental rights and freedoms.
              </li>
            </ul>
          </div>

          <div class="section">
            <h3 style={{ color: "purple" }}>Changes to this Policy</h3>
            <p>
              This Privacy Policy reflects our information security and data
              protection practices. If any material changes are made in the
              contents of this policy, <strong>Cognitude Technologies</strong>{" "}
              will also let you know via a prominent notice on our services,
              prior to the changes coming into effect, and we will update the
              “Effective Date” at the top of this Policy. Changes to this Policy
              are effective when they are published on this page.
            </p>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default DataPrivacy;
